module.exports = __webpack_public_path__ + "img/2-forSocial.5aa767de.gif";